import React, { useRef, useState } from "react";
import Media from "../../Interfaces/MediaInterface";
import { getSrcSet } from "../../Helpers/WindowHelpers";

interface VideoWithPosterProps {
    image: Media;
    video: Media;
    sizes?: string;
    className?: string;
    sectionId?: string | number;
}

const VideoWithPoster = ({
    video,
    image,
    sizes = "100vw",
    className = "",
    sectionId = "video",
}: VideoWithPosterProps) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [showVideo, setShowVideo] = useState(false);

    const handlePlayClick = () => {
        setShowVideo(true);
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    return (
        <div className={`video-with-poster ${className}`}>
            <div
                className={`js-video-poster round width--100 relative ratio ratio--16-9${showVideo ? " hide" : ""}`}
                onClick={handlePlayClick}
                style={{ cursor: "pointer" }}
            >
                <img
                    src={image.src}
                    srcSet={getSrcSet(image.src, [400, 600, 800, 1200, 1600])}
                    sizes={sizes}
                    alt={image.alt || ""}
                    className="ratio__content ratio__content--cover"
                    loading="lazy"
                    data-id={`video-${sectionId}`}
                    width={video.width || image.width}
                    height={video.height || image.height}
                />
                <button className="absolute play-button" aria-label="Play video" type="button">
                    {/* Replace with your icon component or SVG */}
                    <svg width="68" height="68" viewBox="0 0 68 68" fill="none">
                        <circle cx="34" cy="34" r="34" fill="#fff" />
                        <polygon points="27,22 27,46 49,34" fill="#000" />
                    </svg>
                </button>
            </div>
            <video
                ref={videoRef}
                id={`video-${sectionId}`}
                controls
                autoPlay={showVideo}
                className={`html-video overflow-hidden round--md width--100${showVideo ? "" : " hide"}`}
                width={video.width || image.width}
                height={video.height || image.height}
            >
                <source src={video.src} />
            </video>
        </div>
    );
};

export default VideoWithPoster;